import { Alert, Spin } from 'antd';
import React from 'react';

import { EmergencyScenarioSyncStatus as EmergencyScenarioSyncStatus_enum } from '../../../../graphql/api/generated';

interface IEmergencyScenarioSyncStatusColumnProps {
  syncStatus: EmergencyScenarioSyncStatus_enum;
  statusMessage: string;
}

export const EmergencyScenarioSyncStatusColumn: React.FC<IEmergencyScenarioSyncStatusColumnProps> = (props) => {
  const { syncStatus, statusMessage } = props;

  if (syncStatus === EmergencyScenarioSyncStatus_enum.WAITING) {
    return (
      <>
        <Spin size='small' style={{ marginRight: 8 }} />
        {statusMessage}
      </>
    );
  }

  const alertType = syncStatus === EmergencyScenarioSyncStatus_enum.ERROR
    ? 'error'
    : 'success';

  return <Alert showIcon type={alertType} message={statusMessage} />;
};
